/**
 * Created by kellermaca on 8/08/17.
 */
import Vue from 'vue'
import Vuex from 'vuex'
import router from '../../router/index'
import Pusher from 'pusher-js'
const socket = new Pusher('0f66b39deba2f0946ccb', {
  cluster: 'us2',
  encrypted: true,
  enabledTransports: ['ws']
})
import resource from 'vue-resource'
import {
  baseurl, clientesurl, comprasurl, detallecomprastemporalesurl,
  facturaurl, cotizacionurl, devolucionesurl, kilometrajeurl,
  kilometrajevendedorurl, productourl, urlpresentaciones,
  lineafacturaurl, lineacotizacion, rutas, proveedoresurl,
  ubicacionrutas, vehiculos, extracciones, caja,
  tipoextracciones, lineanotacreditourl, notacreditourl, usuarios, bancos
} from '../../plugins/urlsbackend'

Vue.use(resource)
Vue.use(Vuex)
export default {
  login ({commit}, payload) {
    Vue.http.post(baseurl + '/api-token-auth/', {username: payload.username, password: payload.password
    }).then(response => {
      console.log(response.body)
      localStorage.setItem('usuario', payload.username)
      localStorage.setItem('tipo', response.body.tipo)
      localStorage.setItem('puede_vender_bodega', response.body.puede_vender_bodega)
      commit('actualizartipo', response.body.tipo)
      commit('actualizarbodega', response.body.puede_vender_bodega)
      commit('redirect', response.body.token)
      socket.connect()
      var channel = socket.subscribe('my-channel')
      channel.bind('my-event', function (data) {
        alert(data.message)
      })
    }, (response) => { commit('error_login') })
  },
  logout ({commit}) {
    Vue.http.get(baseurl + '/base/logout', {params: {token: localStorage.getItem('token')}}).then(response => {
      commit('resetfactura')
      commit('redirectlogout')
      socket.disconnect()
    }, response => {
      localStorage.removeItem('usuario')
      commit('resetfactura')
      commit('redirectlogout')
    })
  },
  getfacturas ({commit}) {
    Vue.http.get(facturaurl, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      commit('acturalizarfacturas', response.body)
    }, response => {
      console.log('')
    })
  },
  getCompras ({commit}) {
    Vue.http.get(comprasurl, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      commit('actualizarcompras', response.body)
      console.log(response.body)
    }, response => {
      console.log('')
    })
  },
  getkilometraje ({commit}) {
    Vue.http.get(kilometrajeurl, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      commit('actualizarkilometraje', response.body)
    }, response => {
      console.log('')
    })
  },
  getkilometrajevendedor ({commit}) {
    Vue.http.get(kilometrajevendedorurl, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      commit('actualizarkilometrajevendedor', response.body)
    }, response => {
      console.log('')
    })
  },
  getpresentaciones ({commit}) {
    Vue.http.get(urlpresentaciones, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      commit('setPresentaciones', response.body.results)
    }, response => {
      console.log('')
    })
  },
  buscarclientes ({commit}, nit) {
    Vue.http.get(clientesurl, {params: {search: nit}, headers: {'Authorization': 'Token ' + localStorage.getItem('token')}})
      .then(response => {
        if (response.body.count === 0) {
          commit('error_searchcliente', true)
          commit('actualizarcliente', {nombre: '', direccion: ''})
        }
        let data = response.body.results[0]
        data['cliente'] = response.url
        commit('actualizarcliente', data)
        commit('error_searchcliente', false)
      }, (response) => {
        console.log('')
      })
  },
  async crearcliente ({commit}, payload) {
    Vue.http.post(clientesurl, payload, {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        alert('se guardo existosamente')
        commit('actualizarcliente', response.body)
        commit('actualizardialog', false)
        commit('error_searchcliente', false)
        commit('setactivadorcliente', false)
      }, (response) => {
        alert(JSON.stringify(response.bodyText))
        commit('setactivadorcliente', false)
      })
  },
  async crearclientecotizacion ({commit}, payload) {
    Vue.http.post(cotizacionurl, payload, {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('actualizarclientecotizacion', response.body)
        commit('actualizarestadocotizacion', true)
      }, (response) => {
        console.log(response)
        alert(JSON.stringify(response.body))
      })
  },
  async crearfactura ({commit}, payload) {
    const permissionStatus = await navigator.permissions.query({ name: 'geolocation' })
    if (permissionStatus.state === 'denied') {
      alert('Debes otorgar permiso de ubicación para continuar.')
      return
    } else {
      Vue.http.post(facturaurl, {'cliente': payload}, {headers: {
        'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
          commit('actualizarfactura', response.body)
          commit('actualizarestadofactura', true)
          router.push('/facturaadd')
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
            function (position) {
              Vue.http.post(ubicacionrutas, {
                'fecha': new Date(response.body.fecha).toISOString().substring(0, 10),
                'vendedor': response.body.usuario.id,
                'hora_factura': new Date(response.body.fecha).toTimeString(),
                'hora_localizacion': new Date(response.body.fecha).toTimeString(),
                'lugar': response.body.cliente_name,
                'cliente': response.body.cliente,
                'coordenadas': position.coords.latitude + ',' + position.coords.longitude
              }, {headers: {
                'Authorization': 'Token ' + localStorage.getItem('token')
              }}).then(response => {
                console.log('')
              })
            }
          )
          } else {
            alert('Geolocation is not supported by this browser.')
          }
        }, (response) => {
          alert(response.body['non_field_errors'])
          commit('error_searchcliente', true)
        })
    }
  },
  async crearkilometraje ({commit}, payload) {
    Vue.http.post(kilometrajeurl, payload, {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('agregarkilometraje', response.body)
        window.location.reload()
        commit('actualizarakilometraje', {fecha: '', vehiculo: '', kilometraje: ''})
      }, (response) => {
        alert(response.body['non_field_errors'])
        commit('error_searchcliente', true)
      })
  },
  async crearkilometrajevendedor ({commit}, payload) {
    console.log(payload)
    if (payload.id) {
      Vue.http.put(kilometrajevendedorurl + payload.id + '/', payload, {headers: {
        'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
          commit('actualizarkilometrajevendedoretit', response.body)
          commit('actualizarakilometrajevendedor', {kilometraje_inicial: '', kilometraje_final: '', usuario: ''})
        }, (response) => {
          alert(response.body['non_field_errors'])
          commit('error_searchcliente', true)
        })
    } else {
      Vue.http.post(kilometrajevendedorurl, payload, {headers: {
        'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
          commit('agregarkilometrajevendedor', response.body)
          commit('actualizarakilometrajevendedor', {fecha: '', kilometraje_inicial: '', kilometraje_final: '', usuario: ''})
        }, (response) => {
          alert(response.body['non_field_errors'])
          commit('error_searchcliente', true)
        })
    }
  },
  async crearCompra ({commit}, payload) {
    Vue.http.post(comprasurl, payload, {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('setcompra', response.body)
        commit('seteditcompra', true)
        commit('setcompralinea', response.body.id)
        alert('guardado exitosamente')
      }, (response) => {
        alert(response.bodyText)
      })
  },
  async crearLineaCompra ({commit, state}, payload) {
    payload['compra'] = state.compra.id
    Vue.http.post(detallecomprastemporalesurl, payload, {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('setaddlineacompra', response.body)
        commit('limpiarlineacompra', {presentacion: 7, fecha_vencimiento: ''})
        commit('actualizardialog', false)
        commit('aumentartotalc', payload)
        alert('guardado exitosamente')
      }, (response) => {
        alert(response.bodyText)
      })
  },
  async crearfactura2 ({commit, dispatch}, payload) {
    Vue.http.post(facturaurl, {'cliente': payload}, {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('resetfactura')
        commit('actualizarfactura', response.body)
        commit('actualizarestadofactura', true)
        dispatch('getcliente', response.body.cliente)
      }, (response) => {
        commit('error_searchcliente', true)
      })
  },
  buscarproducto ({commit}, params) {
    Vue.http.get(productourl, {params: {search: params.producto, bodega: params.bodega}, headers: {'Authorization': 'Token ' + localStorage.getItem('token')}})
      .then(response => {
        if (response.body.count === 0) {
          commit('actualizarproducto', {producto: '', listaprecios: [], precio_costo: '', barra: ''})
        }
        let producto = response.body.results[0]
        commit('actualizarproducto', producto)
        commit('actualizarpresentaciones', [])
        commit('actualizarpresentaciones', {'presentacion': 'unidad', 'unidades': 1})
        commit('actualizarpresentaciones', producto.presentacion)
        commit('actualizarpresentacion', {'presentacion': 'unidad', 'unidades': 1})
        let lista = producto.listaprecios.find(dato => {
          return dato.lista.nombre.toLowerCase() === 'detalle' || dato.lista.nombre.toLowerCase() === 'l6' || dato.lista.nombre.toLowerCase() === 'l8'
        })
        commit('updateselect', lista)
      }, response => {
        commit('actualizarproducto', {producto: '', listaprecios: [], precio_costo: '', codigo: '', barra: ''})
      })
  },
  async insertarlinea ({commit}, payload) {
    await Vue.http.post(lineafacturaurl, payload, {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('actualizarlinea', response.body)
        commit('actualizarpresentacion', {})
        commit('actualizarpresentaciones', [])
        commit('actualizarproducto', {producto: '', listaprecios: [], precio_costo: '', codigo: ' ', barra: ' '})
        commit('limpiarbarra', '')
        commit('setguardando', false)
        commit('actualizarerror', false)
        commit('actualizarmessage_error', '')
      }, (response) => {
        console.log(response)
        commit('setguardando', false)
        commit('actualizarerror', true)
        if (response.body['non_field_errors']) {
          commit('actualizarmessage_error', response.body['non_field_errors'][0])
        } else {
          commit('actualizarmessage_error', response.bodyText)
        }
      })
  },
  async insertarlineanotacredito ({commit}, payload) {
    payload['nota_credito'] = 100
    return Vue.http.post(lineanotacreditourl, payload, {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('setLineaNota', response.body.nota_credito)
        if (response.body.nota_credito.motivo_anulacion) {
          'pass'
        } else {
          commit('actualizardialog', true)
        }
      }, (response) => {
        console.log(response)
        commit('actualizarerror', true)
        if (response.body['non_field_errors']) {
          commit('actualizarmessage_error', response.body['non_field_errors'][0])
        } else {
          commit('actualizarmessage_error', response.bodyText)
        }
      })
  },
  async insertarlineacotizacion ({commit}, payload) {
    Vue.http.post(lineacotizacion, payload, {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('actualizarlineacotizacion', response.body)
        commit('actualizarpresentacion', {})
        commit('actualizarpresentaciones', [])
        commit('actualizarproducto', {producto: '', listaprecios: [], precio_costo: '', codigo: '', barra: ''})
        commit('actualizarerror', false)
        commit('actualizarmessage_error', '')
      }, (response) => {
        console.log(response)
        commit('actualizarerror', true)
        commit('actualizarmessage_error', response.body['non_field_errors'][0])
      })
  },
  actualizartipofactura ({commit}, payload) {
    Vue.http.patch(facturaurl + payload.factura.id + '/', {credito: payload.factura.credito, cliente: payload.factura.cliente}, {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('actualizarfactura', response.body)
        if (response.body.message.length > 0) {
          alert(response.body.message)
        }
      }, function (response) {
        payload.factura.credito = false
        commit('actualizarfactura', payload)
        alert(response.bodyText)
      })
  },
  actualizarcomentario ({commit, state}, payload) {
    Vue.http.patch(facturaurl + payload.factura.id + '/', {observaciones: payload.factura.observaciones,
      cliente: payload.factura.cliente,
      observacionesmotivo: payload.factura.observacionesmotivo}, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('actualizarfactura', response.body)
      }, function (response) {
        alert(response.body.non_field_errors)
        payload.factura.observaciones = state.messageactual
        commit('actualizarfactura', payload)
      })
  },
  actualizarnotacredito ({commit}, payload) {
    Vue.http.patch(notacreditourl + payload.id + '/', {motivo_anulacion: payload.motivo}, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      commit('actualizardialog', false)
    }, function (response) {
    })
  },
  actualizarenvio ({commit}, payload) {
    Vue.http.patch(facturaurl + payload.factura.id + '/', {envio: payload.factura.envio, cliente: payload.factura.cliente}, {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('actualizarfactura', response.body)
      }, function (response) {
        payload.envio = false
        commit('actualizarfactura', payload)
      })
  },
  async actualizaranulado ({commit}, payload) {
    Vue.http.patch(facturaurl + payload.factura.id + '/', {rechazado: payload.factura.anulado, motivo_anulacion: payload.factura.motivo_anulacion, cliente: payload.factura.cliente}, {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('actualizarfactura', response.body)
      }, function (response) {
        payload.anulado = false
        commit('actualizarfactura', payload)
      })
  },
  actualizarbodega ({commit}, payload) {
    Vue.http.patch(facturaurl + payload.factura.id + '/', {bodega: payload.factura.bodega, cliente: payload.factura.cliente}, {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('actualizarfactura', response.body)
      }, function (response) {
        commit('actualizarfactura', payload)
      })
  },
  async eliminarlineafactura ({commit}, payload) {
    await Vue.http.delete(lineafacturaurl + payload.id + '/', {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('eliminarlinea', payload)
        commit('setEliminando', false)
      }, function (response) {
        alert(response.body.non_field_errors)
      })
  },
  async eliminarlineacompra ({commit}, payload) {
    Vue.http.delete(detallecomprastemporalesurl + payload.id + '/', {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('disminuirtotalc', payload)
        commit('eliminarlineacompra', payload)
      }, function (response) {
        alert(response.body.non_field_errors)
      })
  },
  async eliminarlineacotizacion ({commit}, payload) {
    Vue.http.delete(lineacotizacion + payload.id + '/', {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('eliminarlineacotizacion', payload)
      })
  },
  async actualizarnumerofactura ({commit}, payload) {
    Vue.http.get(baseurl + '/apicatalogos/pdfgenerationindividual',
      {params: {
        id: payload.factura.id
      },
        headers: {'Authorization': 'Token ' + localStorage.getItem('token')},
        responseType: 'arraybuffer'}).then(response => {
          let blob = new Blob([response.body], {type: 'application/pdf'})
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          let imprimir = window.open(link.href)
          imprimir.print()
          commit('actualizardialog', false)
          commit('resetfactura')
          router.push('/facturaadd')
        }, function (response) {
          let string = JSON.parse(new TextDecoder().decode(response.body))
          commit('actualizarerror', true)
          commit('actualizarmessage_error', string.reason)
        })
  },
  imprimirfacturaelectronica ({ commit, dispatch }, payload) {
    console.log(payload)
    Vue.http.get(baseurl + '/apicatalogos/pdfgenerationindividualelectronica',
      {params: {
        id: payload.factura.id
      },
        headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
          dispatch('checkstatustask', {'task_id': response.data.data.task_id, 'facturas': response.data.data.facturas})
        }, function (response) {
          let string = JSON.parse(new TextDecoder().decode(response.body))
          commit('actualizarerror', true)
          commit('actualizarmessage_error', string.reason)
        })
  },
  checkstatustask ({commit, dispatch, getters}, payload) {
    Vue.http.get(baseurl + '/apicatalogos/estadotarea',
      {params: {
        id: payload.task_id,
        facturas: payload.facturas
      },
        headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
          console.log(response)
          if (response.data.data.state === 'PROGRESS') {
            console.log('se ejecuto bien')
          } else if (response.data.data.state === 'PENDING') {
            console.log('por favor espere')
            setTimeout(function () {
              dispatch('checkstatustask', response.data.data)
            }, 1000)
          } else if (response.data.data.state === 'SUCCESS') {
            Vue.http.post('http://127.0.0.1:5000/', response.data).then(response => {
              let ids = getters.getidfactura
              dispatch('imprimirfacturaelectronica2', {factura: {id: ids.pop()}})
              commit('setidsfactura', ids)
              commit('actualizardialog', false)
              commit('resetfactura')
              router.push('/facturaadd')
            }, response => {
              alert('ocurrio un error la impresora no está conectada')
            })
          } else if (response.data.data.state === 'FAILURE') {
            console.log('paso algún error')
          } else {
            console.log('no es igual')
            setTimeout(function () {
              dispatch('checkstatustask', response.data.data)
            }, 100)
          }
        }, function (response) {
          alert('ocurrio un erro inesperado ')
        })
  },
  imprimirfacturaelectronica2 ({ commit, dispatch }, payload) {
    console.log(payload)
    Vue.http.get(baseurl + '/apicatalogos/pdfgenerationindividualelectronica',
      {params: {
        id: payload.factura.id
      },
        headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
          dispatch('checkstatustask', {'task_id': response.data.data.task_id, 'facturas': response.data.data.facturas})
        }, function (response) {
          let string = JSON.parse(new TextDecoder().decode(response.body))
          commit('actualizarerror', true)
          commit('actualizarmessage_error', string.reason)
        })
  },
  checkstatustask2 ({commit, dispatch}, payload) {
    Vue.http.get(baseurl + '/apicatalogos/estadotarea',
      {params: {
        id: payload.task_id,
        facturas: payload.facturas
      },
        headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
          console.log(response)
          if (response.data.data.state === 'PROGRESS') {
            console.log('se ejecuto bien')
          } else if (response.data.data.state === 'PENDING') {
            console.log('por favor espere')
            setTimeout(function () {
              dispatch('checkstatustask', response.data.data)
            }, 100)
          } else if (response.data.data.state === 'SUCCESS') {
            setTimeout(Vue.http.post('http://127.0.0.1:5000/', response.data).then(response => {
              alert('finalizado con éxito')
            }, response => {
              alert('ocurrio un error la impresora no está conectada')
            }), 500)
          } else if (response.data.data.state === 'FAILURE') {
            console.log('paso algún error')
          } else {
            console.log('no es igual')
            setTimeout(function () {
              dispatch('checkstatustask', response.data.data)
            }, 100)
          }
        }, function (response) {
          alert('ocurrio un erro inesperado ')
        })
  },
  imprimircotizacion ({commit}, payload) {
    Vue.http.get(baseurl + '/apicatalogos/pdfgenerationcotizacion',
      {params: {
        id: payload.cotizacion.id
      },
        headers: {'Authorization': 'Token ' + localStorage.getItem('token')},
        responseType: 'arraybuffer'}).then(response => {
          let blob = new Blob([response.body], {type: 'application/pdf'})
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          let imprimir = window.open(link.href)
          imprimir.print()
          commit('actualizardialog', false)
          commit('resetcotizacion')
          router.push('/cotizacionadd')
        }, function (response) {
          let string = JSON.parse(new TextDecoder().decode(response.body))
          commit('actualizarerror', true)
          commit('actualizarmessage_error', string.reason)
        })
  },
  guardarfactura ({commit}, payload) {
    Vue.http.patch(facturaurl + payload.factura.id + '/',
      {estado: true}, {headers: {
        'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
          commit('resetfactura')
          router.push('/facturaadd')
        }, function (response) {
          commit('actualizarerror', true)
          commit('actualizarmessage_error', response.body['non_field_errors'][0])
        })
  },
  actualizarcompra ({commit}, payload) {
    Vue.http.put(comprasurl + payload.id + '/',
      payload, {headers: {
        'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
          commit('seteditcompra', true)
          alert('actualizada exitosamente')
        }, function (response) {
          commit('actualizarerror', true)
          commit('actualizarmessage_error', response.body['non_field_errors'][0])
        })
  },
  guardarcotizacion ({commit}, payload) {
    commit('resetcotizacion')
    router.push('/cotizacionadd')
  },
  actualizarfacturas ({commit}, payload) {
    Vue.http.get(facturaurl, {params: payload, headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      commit('actualizarlistadofacturas', response.body)
    })
  },
  actualizardevoluciones ({commit}, payload) {
    Vue.http.get(devolucionesurl, {params: payload, headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      commit('setdevoluciones', response.body)
    })
  },
  actualizarcotizaciones ({commit}, payload) {
    Vue.http.get(cotizacionurl, {params: payload, headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      commit('actualizarlistadocotizaciones', response.body)
    })
  },
  actualizarfacturas2 ({commit}, url) {
    Vue.http.get(url, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      commit('actualizarlistadofacturas', response.body)
    })
  },
  async eliminarfactura ({commit}, payload) {
    Vue.http.delete(facturaurl + payload.id + '/', {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('eliminarfactura', payload)
        commit('actualizarestadofactura', false)
        commit('resetfactura')
      }, function (response) {
        alert(response.body.non_field_errors)
      })
  },
  async eliminarcompra ({commit}, payload) {
    Vue.http.delete(comprasurl + payload.id + '/', {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('eliminarcompra', payload)
      }, function (response) {
        alert(response.body.non_field_errors)
      })
  },
  async eliminarcotizacion ({commit}, payload) {
    Vue.http.delete(cotizacionurl + payload.id + '/', {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('eliminarcotizacion', payload)
        commit('actualizarestadocotizacion', false)
      })
  },
  async eliminarextraccion ({commit}, payload) {
    Vue.http.delete(extracciones + payload.id + '/', {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('eliminarextraccion', payload)
      })
  },
  getcliente ({commit}, url) {
    Vue.http.get(clientesurl + url + '/', {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}})
      .then(response => {
        let data = response.body
        data['cliente'] = response.url
        commit('actualizarcliente', data)
        commit('error_searchcliente', false)
      }, (response) => {
        commit('error_searchcliente', true)
        commit('actualizarcliente', {nombre: '', direccion: ''})
      })
  },
  getclientes ({commit, state}, clientes = clientesurl) {
    if (state.dia !== null || state.semana !== null || state.ruta !== null) {
      let payload = {'dia': state.dia, 'semana': state.semana, ruta: state.ruta.nombre}
      Vue.http.get(clientes, {params: payload, headers: {'Authorization': 'Token ' + localStorage.getItem('token')}})
      .then(response => {
        let data = response.body
        data['cliente'] = response.url
        commit('actualizarclientes', data)
      }, (response) => {
        console.log('')
      })
    } else {
      Vue.http.get(clientes, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}})
      .then(response => {
        let data = response.body
        data['cliente'] = response.url
        commit('actualizarclientes', data)
      }, (response) => {
        console.log('')
      })
    }
  },
  eliminarcliente ({commit}, payload) {
    Vue.http.patch(clientesurl + payload.id + '/', {eliminado: 'True'}, {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('eliminarcliente', payload)
      }, response => {
        alert(response.bodyText)
      })
  },
  eliminarkilometraje ({commit}, payload) {
    Vue.http.delete(kilometrajeurl + payload.id + '/', {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('eliminarkilometraje', payload)
      })
  },
  eliminarkilometrajevendedor ({commit}, payload) {
    Vue.http.delete(kilometrajevendedorurl + payload.id + '/', {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('eliminarkilometrajevendedor', payload)
      })
  },
  editarcliente ({commit}, payload, notify) {
    Vue.http.put(clientesurl + payload.id + '/', payload, {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        console.log(response)
        commit('actualizardialog', false)
        commit('setactivadorcliente', false)
        commit('limpiarcliente')
        commit('actualizarclientesedit', payload)
        if (notify) {
          alert('Modificado Exitosamente')
        }
      }, response => { console.log(response) })
  },
  editarclientefactura ({commit}, payload) {
    Vue.http.put(clientesurl + payload.id + '/', payload, {headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
        commit('actualizarcliente', response.body)
        alert('Modificado Exitosamente')
      }, response => { alert(JSON.stringify(response.bodyText)) })
  },
  filter ({commit}, payload) {
    console.log(payload)
    Vue.http.get(clientesurl, {params: payload, headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      let data = response.body
      console.log(response.url)
      data['cliente'] = response.url
      commit('actualizarclientes', data)
    }, response => {
      console.log('error')
    })
  },
  getrutas ({commit}) {
    Vue.http.get(rutas, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      commit('actualizarrutas', response.body.results)
    })
  },
  getbancos ({commit}) {
    Vue.http.get(bancos, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      commit('actualizarbancos', response.body.results)
    })
  },
  getusuarios ({commit}) {
    Vue.http.get(usuarios, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      commit('actualizarusuarios', response.body.results)
    })
  },
  getproveedores ({commit}) {
    Vue.http.get(proveedoresurl + '?limit=1000', {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      commit('actualizarproveedores', response.body.results)
    })
  },
  buscarproductos ({commit}, params) {
    Vue.http.get(productourl, {params: {search: params.producto, bodega: params.bodega}, headers: {'Authorization': 'Token ' + localStorage.getItem('token')}})
      .then(response => {
        let producto = response.body.results
        commit('actualizarproductos', producto)
      }, response => {
        commit('actualizarproducto', {producto: '', listaprecios: [], precio_costo: '', codigo: '', barra: ''})
      })
  },
  getvehiculos ({commit}) {
    Vue.http.get(vehiculos, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      commit('actualizarvehiculos', response.body.results)
    })
  },
  requestextracciones ({commit}) {
    Vue.http.get(extracciones, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      commit('setextracciones', response.body.results)
    })
  },
  requesttipoextracciones ({commit}) {
    Vue.http.get(tipoextracciones, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      commit('settipoextracciones', response.body.results)
    })
  },
  requestcaja ({commit}) {
    Vue.http.get(caja, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      commit('setcaja', response.body.results)
    })
  },
  guardarextraccion ({commit}, payload) {
    Vue.http.post(extracciones, payload, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      router.push('/extraccion')
    },
      response => {
        alert(response.bodyText)
      })
  },
  guardardevolucion ({commit}, payload) {
    Vue.http.post(devolucionesurl, payload, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}).then(response => {
      commit('setdevoluciones', {})
      alert(response.bodyText)
    },
      response => {
        alert(response.bodyText)
      })
  }

}



// WEBPACK FOOTER //
// ./src/store/actions/actions.js